import { ToastT } from "sonner";
import z from "zod";

// #region Fetch Response and JWT Types
export type FetchResponse = {
  status: number;
  data: unknown;
  error?: string;
};

export const tokensSchema = z.object({
  authToken: z.string(),
  refreshToken: z.string(),
});

export type Tokens = z.infer<typeof tokensSchema>;

export type SocketCom = {
  command: "auth" | "login" | "refresh-Token" | "register-user";
  data: unknown;
  // http status code used for incoming messages
  status?: number;
};

export const newAlertSchema = z.object({
  // TODO: Change per client requirements
  id: z.number(),
  timestamp: z.number(),
  alertLevel: z.enum(["info", "warning", "error"]),
  alertType: z.enum(["clientRequirement"]),
});

export type NewAlert = z.infer<typeof newAlertSchema>;

export const dropDownMenuItemSchema = z.object({
  label: z.string(),
  onClick: z.custom<() => void>().optional(),
  subItems: z
    .array(
      z.object({
        label: z.string(),
        onClick: z.custom<() => void>().optional(),
      })
    )
    .optional(),
});

export type DropDownMenuItem = z.infer<typeof dropDownMenuItemSchema>;

export const AUTH_METHODS = [
  "Google",
  "Office 365",
  "Facebook",
  "LinkedIn",
] as const;

export const registerUserSchema = z.object({
  fullName: z.string(),
  email: z.string(),
  password: z.string(),
  authMethod: z.enum(AUTH_METHODS),
  phoneNumber: z.string().optional(),
  companyName: z.string().optional(),
});

export type RegisterUser = z.infer<typeof registerUserSchema>;

// #region ToastOptions
export type ToastOptions = {
  position?: ToastT["position"];
  actionLabel?: string;
  callback?: () => void;
  duration?: number;
};

// #endregion ToastOptions

export const clientConfigSchema = z.object({
  displayName: z.string(),
  logo: z.string(),
  customLoaderImage: z.string(),
  cssVariables: z.record(z.string(), z.string()),
});
export type ClientConfig = z.infer<typeof clientConfigSchema>;

export const loginResponseDataSchema = tokensSchema.extend({
  config: clientConfigSchema.nullable().optional(),
});
export type LoginResponseData = z.infer<typeof loginResponseDataSchema>;

export const chatMessageSchema = z.object({
  id: z.number(),
  sender: z.enum(["account", "agent"]),
  content: z.string().describe("Markdown string"),
  // timestamp: z.number(),
});
export type ChatMessage = z.infer<typeof chatMessageSchema>;

export const agentModelSchema = z.object({
  id: z.number(),
  name: z.string(),
});
export type AgentModel = z.infer<typeof agentModelSchema>;

export const conversationSchema = z.object({
  id: z.number(),
  name: z.string(),
  agentID: z.number(),
  last_date: z.string(),
});
export type Conversation = z.infer<typeof conversationSchema>;

export const newChatMessageResponseSchema = z.object({
  conversation: conversationSchema,
  messages: z.array(chatMessageSchema),
});

export type NewChatMessageResponse = z.infer<
  typeof newChatMessageResponseSchema
>;
